import { rgba } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
import { variables } from 'styleUtils';

const buttonColor = (props) => {
	if (props.color) {
		return variables[props.color];
	} else if (props.inverted) {
		return variables.white;
	}
	return variables.darkGrey;
};

const defaultButtonStyle = (props) => `
  display: inline-block;
  font-size: .875rem;
  padding: 20px 52px;
  color: ${props.color || props.inverted ? variables.darkGrey : variables.white};
  background-color: ${buttonColor(props)};
  border-radius: 31px;
  letter-spacing: .5px;
  font-weight: 100;
  border: none;
  cursor: pointer;

  &.small {
    padding: 15px 30px;
  }

  :hover {
    background-color: ${props.color ? rgba(variables[props.color],
		0.8) : variables.midGrey};
    color: ${props.color ? variables.darkGrey : variables.white};
    transition: all .7s ease;
  }
  :focus {
    outline: none;
  }

  :disabled {
    color: ${props.color || props.inverted ? variables.darkGrey : variables.white};
    background-color: ${buttonColor(props)};
    &:hover {
      cursor: initial;
    }
  }

  ${props.color ? css`
    color: ${variables.darkGrey};
    background-color: ${variables[props.color]};
  ` : ''}

  ${props.large ? css`
    font-size: 20px;
    width: 100%;
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: center;
  ` : ''}
`;

const Button = styled(({
	large, ...rest
}) => (
	<button {...rest} />
))`
  ${props => defaultButtonStyle(props)}
`;

const LinkButton = styled(({
	large, ...rest
}) => (
	<a {...rest} />
))`
  text-decoration: none;
  ${props => defaultButtonStyle(props)}
`;

const outlinedButtonStyles = (props) => `
  background-color: transparent;
  color: ${variables.darkGrey};
  min-width: 150px;
  box-shadow: 0px 0px 0px 1px ${variables.lineColor};
  transition: box-shadow 0.3s ease 0s, border-color .3s ease 0s;
  &:hover {
    background: transparent;
    color: ${variables.darkGrey};
    box-shadow: 0px 0px 0px 3px ${props.color ? variables[props.color] : variables.darkGrey};
    border-color: ${props.color ? variables[props.color] : variables.darkGrey};
    transition: box-shadow 0.3s ease 0s, border-color .3s ease 0s;
  }
`;

const OutlinedButton = styled(Button)`
  ${props => outlinedButtonStyles(props)}
`;

const OutlinedLinkButton = styled(LinkButton)`
  ${props => outlinedButtonStyles(props)}
`;

export {
	defaultButtonStyle, LinkButton, OutlinedButton, OutlinedLinkButton,
};
export default Button;
